import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Chip from '@material-ui/core/Chip'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconCloseSmall } from 'assets/icons/close-small.svg'
import useStyles from './styles'

const Badge = props => {
  const { type, label, onDelete } = props

  const classes = useStyles()
  return (
    <Chip
      variant="outlined"
      size="small"
      label={label}
      deleteIcon={
        <SvgIcon component={IconCloseSmall} className={classes.closeButton} />
      }
      className={clsx(
        classes.root,
        (type === 'validated' || type === 'valid') && classes.isValid,
        type === 'attached' && classes.isAttached,
        type === 'pending' && classes.isPending,
        type === 'expired' && classes.isExpired,
        type === 'rejected' && classes.isRejected,
        onDelete && classes.deletable,
      )}
      {...props}
    />
  )
}

Badge.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string,
}

export default Badge
